export default {"src":"/_next/static/media/downArrow.cd0e6f56.svg","height":5,"width":9,"blurWidth":0,"blurHeight":0};